import React, { Component } from "react";
import { withDomains, RESTExecutor } from "../../lib/domain";
import { Link } from "react-router-dom";
import { Typography, Table, Row, Button, Tag, Input } from "antd";
import {
  NetworkDelaySearch,
  overrideHeaderTitle,
  overrideHeaderBack,
  formatMoney,
} from "../../lib/util";
import ErrorWrapper from "../../lib/error_wrapper";
import { BasicHeader } from "../../components/basic_header";
const queryString = require("query-string");

const { Title, Paragraph, Text } = Typography;

class TableList extends Component {
  constructor(props) {
    super(props);

    this.state = {
      filter_query: {},
    };
    this.list_tables = RESTExecutor.list()
      .config({
        label: "list",
        params: {
          per_page: 100,
        },
      })
      .connect(props.domains.usertable);

    this.delay_search = new NetworkDelaySearch();
  }

  stateUpdater = ({ stateKey, valueKey, value, appendObj = {}, callback }) => {
    let newData = this.state[stateKey];
    this.has_changed = true;
    if (valueKey) {
      newData[valueKey] = value;
    }
    if (appendObj) {
      Object.assign(newData, appendObj);
    }
    console.log(newData);
    this.setState(
      {
        [stateKey]: newData,
      },
      () => {
        typeof callback === "function" && callback();
      }
    );
  };
  render() {
    let list_table_resp = this.list_tables.response();
    let list_table_data = list_table_resp.result || {};
    let rowsData = list_table_data.rows || [];
    let rowsMeta = list_table_resp.meta || {};
    const { filter_query } = this.state;
    return (
      <div>
        <BasicHeader no_back title="Tables" menu_items={[]} />
        <div className="filter-card">
          <div
            className="filter-card-top"
            style={{
              display: "flex",
              flexDirection: "row",
              justifyContent: "space-between",
              flexWrap: "nowrap",
            }}
          >
            <Input.Search
              placeholder="Search For"
              style={{}}
              autoFocus
              value={filter_query.query}
              onChange={(e) => {
                this.stateUpdater({
                  stateKey: "filter_query",
                  valueKey: "query",
                  value: e.target.value,
                  callback: () => {
                    this.delay_search.onSearch(() => {
                      this.props.history.push({
                        search: queryString.stringify({
                          ...this.state.filter_query,
                          per_page: 100,
                          page: 1,
                        }),
                      });
                    });
                  },
                });
              }}
            />
          </div>
        </div>

        <ErrorWrapper
          error={list_table_resp}
          onReload={() => {
            this.list_tables.execute();
          }}
        >
          <div
            className="default-card"
            style={{
              padding: 8,
            }}
          >
            <Table
              scroll={{ x: true }}
              // rowClassName='hand-cursor'
              className="main-table"
              loading={list_table_resp.fetching}
              size="small"
              pagination={{
                onChange: (current, size) => {
                  this.props.history.push({
                    // pathname:"users",
                    search: queryString.stringify({
                      ...this.state.filter_query,
                      per_page: size,
                      page: current,
                    }),
                  });
                  // this.list_tables.config({
                  //     params: {
                  //         per_page: size,
                  //         page: current,
                  //         ...filter_query
                  //     }
                  // }).execute();
                },
                defaultCurrent: 1,
                current:
                  rowsMeta.pagination &&
                  parseInt(rowsMeta.pagination.split("/")[0]),
                // defaultPageSize: 20,
                pageSize: rowsMeta && rowsMeta.requested_count,

                total: rowsMeta && rowsMeta.total_count,
                showTotal: (total, range) =>
                  `${formatMoney(range[0], 0)}-${formatMoney(
                    range[1],
                    0
                  )} of ${formatMoney(total, 0)} items`,
              }}
              // bordered={false}
              rowKey={(record) => record.id}
              columns={[
                {
                  title: "Table Name",
                  dataIndex: "name",
                  key: "name",
                  className: "bold-cell",
                },
                // { title: "Allowed Methods",width:320, dataIndex: 'allowed_methods', key: 'allowed_methods',render:(list_methods=[])=>{
                //   return <span>{
                //     list_methods.map((item)=>{
                //       return <Tag color="#108ee9">{item}</Tag>
                //     })
                //   }</span>

                // }},
                {
                  title: "",
                  dataIndex: "id",
                  key: "id",
                  width: 60,
                  render: (id) => {
                    return (
                      <Link to={`/activity/table/${id}`}>
                        <Button type="link">View</Button>
                      </Link>
                    );
                  },
                },
              ]}
              dataSource={rowsData}
            />
          </div>
        </ErrorWrapper>
      </div>
    );
  }

  componentDidMount() {
    // this.list_tables.execute();
    overrideHeaderTitle("Table List");
    overrideHeaderBack(null);
    let new_filter_query = {};
    if (this.props.location && this.props.location.search) {
      const parsed = queryString.parse(this.props.location.search);
      new_filter_query = parsed;
    }
    this.setState(
      {
        filter_query: {
          per_page: 100,
          page: 1,
          ...new_filter_query,
        },
      },
      () => {
        this.list_tables
          .config({
            params: {
              ...this.state.filter_query,
            },
          })
          .execute();
      }
    );

    // typeof this.props.onChangeTag==='function' && this.props.onChangeTag({tagName:"Source"})
  }

  componentWillReceiveProps(nextProps) {
    let new_filter_query = {};
    if (this.props.location.search !== nextProps.location.search) {
      const parsed = queryString.parse(nextProps.location.search);
      new_filter_query = parsed;
      this.setState(
        {
          filter_query: {
            per_page: 100,
            page: 1,
            ...new_filter_query,
          },
        },
        () => {
          this.list_tables
            .config({
              params: {
                ...this.state.filter_query,
              },
            })
            .execute();
        }
      );
    } else {
      //   this.list_logs.execute()
    }
  }
}

export default withDomains(TableList, "usertable");
